import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import PropTypes from "prop-types";
import { Box, Link } from "@mui/material";
import { Fonts } from "shared/constants/AppEnums";
import AppScrollbar from "@crema/core/AppScrollbar";
import AppList from "@crema/core/AppList";
import { textEllipsis } from "@crema/utility/Utils";

const NewsList = (props) => {
    const { data } = props;

    return (
        <AppScrollbar>
            <List
                sx={{
                    pt: 3,
                }}
            >
                <AppList
                    data={data}
                    renderRow={(news) => {
                        return (
                            <ListItem
                                key={`${news.id}-${news.newsCreatedOn}`}
                                className="item-hover"
                                sx={{
                                    px: 5,
                                    py: 3,
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: { xs: "column", sm: "row" },
                                    borderTop: "1px solid #efefef",
                                }}
                                component={Link}
                                href={`news/${news.newsId}`}
                            >
                                <Box
                                    sx={{
                                        mr: { sm: 3, xl: 5 },
                                        width: { xs: "100%", sm: "auto" },
                                        "& .newsImg": {
                                            width: { xs: "100%", sm: "60px" },
                                            height: { xs: "100%", sm: "60px" },
                                            display: "block",
                                        },
                                    }}
                                >
                                    <img
                                        className="newsImg"
                                        src={news.filename}
                                        alt="image"
                                    />
                                </Box>
                                <ListItemText
                                    sx={{
                                        flex: "1 1 0",
                                    }}
                                    primary={
                                        <Box
                                            sx={{
                                                color: "text.primary",
                                                fontWeight: Fonts.MEDIUM,
                                                fontSize: 16,
                                                lineHeight: 1,
                                                mb: 1,
                                            }}
                                        >
                                            {textEllipsis(news.newsTitle, 15)}
                                        </Box>
                                    }
                                    secondary={
                                        <Box
                                            component="span"
                                            sx={{
                                                color: "text.secondary",
                                                fontSize: 12,
                                            }}
                                        >
                                            {textEllipsis(
                                                news.newsDescription,
                                                45
                                            )}
                                        </Box>
                                    }
                                />
                            </ListItem>
                        );
                    }}
                />
            </List>
        </AppScrollbar>
    );
};

export default NewsList;

NewsList.defaultProps = {
    data: [],
};

NewsList.propTypes = {
    data: PropTypes.array,
};
